<template>
  <div :class="$style.root">
    <ShopFilter :class="$style.filter" :category.sync="category" />
    <transition-group
      :class="$style.itemList"
        v-if="!isFittingMode"
      tag="div"
      :move-class="$style.itemMove"
      :enter-class="[$style.itemEnter].join(' ')"
      :enter-active-class="[$style.itemAnimated].join(' ')"
      :leave-active-class="[$style.itemAnimated, $style.itemLeaveActive].join(' ')"
    >
      <ShopItem
        v-for="item in filteredItems"
        :key="item.id"
        :class="$style.item"
        :item="item"
        showPurchase
      />
    </transition-group>
    <FittingRoom v-if="isFittingMode" :class="$style.itemList">
      <template #item="props">
        <ShopItem :item="props.item" :class="$style.item" showApply />
      </template>
    </FittingRoom>
  </div>
</template>

<script>
import ShopItem from '@/components/Shop/Item'
import ShopFilter from '@/components/Shop/Filter'
import { mapGetters, mapActions } from 'vuex'
import FittingRoom from '@/components/Shop/FittingRoom'

export const PURCHASED_CATEGORY = '_purchased'

export default {
  components: {
    ShopItem,
    ShopFilter,
    FittingRoom,
  },
  data () {
    return {
      category: null,
    }
  },
  async created () {
    await this.getProfile()
    await this.getItems()
  },
  computed: {
    isFittingMode () {
      return this.category == PURCHASED_CATEGORY
    },
    filteredItems () {
      if (!this.category) {
        return this.items
      }
      if (this.category == PURCHASED_CATEGORY) {
        return this.purchasedItems
      }
      return this.itemsOf(this.category)
    },
    ...mapGetters('shop', {
      items: 'items',
      itemsOf: 'itemsOf',
      purchasedItems: 'purchasedItems',
    }),
  },
  methods: {
    ...mapActions('auth', {
      getProfile: 'getProfile',
    }),
    ...mapActions('shop', {
      getItems: 'getItems',
    }),
  },
}
</script>

<style lang="scss" module>
.root {
  @apply h-full;
  @apply w-full;
  @apply overflow-y-scroll;
  @apply scrolling-touch;
}

.filter {
  @apply mx-6;
  @apply mt-4;
  @apply mb-2;
  @apply pb-2;
  border-bottom: 1px solid #7b3300;
}

.itemList {
  @apply mx-4;
  @apply flex;
  @apply flex-wrap;
  @apply mb-6;
}

.item {
  @apply m-2;
}

.itemAnimated {
  transition: all .3s;
}

.itemMove {
  transition: all .6s;
}

.itemEnter {
  @apply opacity-0;
  transform: scale(0.86);
}

.itemLeaveActive {
  @apply absolute;
  @apply z-0;
  @apply opacity-0;
}
</style>
